import { CategorieDtoToCategorie, CategorieListDtoToCategorieList, } from '../../../mappers/faq';
import { api } from '../api';
export const FAQCategoriesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getCategories: builder.query({
            query: () => ({
                url: 'api/FAQCategoria/',
                method: 'get',
            }),
            providesTags: ['Faq'],
            transformResponse: (response) => CategorieListDtoToCategorieList(response),
        }),
        getCatById: builder.query({
            query: ({ id }) => ({
                url: `api/FAQCategoria/${id}`,
                method: 'get',
            }),
            providesTags: ['Faq'],
            transformResponse: (response) => CategorieDtoToCategorie(response),
        }),
        addCategorie: builder.mutation({
            query: ({ title, desc }) => ({
                url: 'api/FAQCategoria/',
                method: 'post',
                data: {
                    Titulo: title,
                    Descricao: desc,
                },
            }),
            invalidatesTags: ['Faq'],
        }),
        updateCategorie: builder.mutation({
            query: ({ title, desc, index, id }) => ({
                url: `api/FAQCategoria/${id}`,
                method: 'put',
                data: {
                    Titulo: title,
                    Descricao: desc,
                    Ordem: index,
                },
            }),
            invalidatesTags: ['Faq'],
        }),
        deleteCategorie: builder.mutation({
            query: ({ id }) => ({
                url: `api/FAQCategoria/${id}`,
                method: 'delete',
            }),
            invalidatesTags: ['Faq'],
        }),
    }),
});
export const { useGetCategoriesQuery, useGetCatByIdQuery, useAddCategorieMutation, useUpdateCategorieMutation, useDeleteCategorieMutation, } = FAQCategoriesApi;
